


































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import AlpacaBtn from '@/components/AlpacaBtn.vue';
import { EventBus } from '@/utils/EventBus';
import {
  validateAccount,
  tokenPurchase,
  canTokenPurchaseAmount,
  tokenPresaleRemaining,
  tokenRaisedFund,
  userETHBalance,
  exchangeRate,
} from '@/utils/web3';
import BigNumber from 'bignumber.js';
import { alpaUnit } from '@/utils/unit';

@Component({
  components: {
    AlpacaBtn,
  },
})
export default class TokenPresale extends Vue {
  public count: string = '0';
  public userRemaining: number = 0;
  public presaleRemaining: number = 0;
  public tokenRaisedFund: number = 0;
  public userETHBalance: number = 0;
  public exchangeRate: number = 1;

  get account() {
    return this.$store.getters.getAccount;
  }

  get minRemaing() {
    return Math.min(Math.min(this.userRemaining, this.presaleRemaining), this.userETHBalance);
  }

  get canPurchase() {
    return this.minRemaing >= Number(this.count);
  }

  get presaleEnd() {
    return this.presaleRemaining === 0;
  }

  public mounted() {
    this.countChange();
    this.getUserRemaining();
    this.getPresaleRemaining();
    this.getTokenRaisedFund();
    this.getUserETHBalance();
    this.getExchangeRate();
  }

  public async connectWallet() {
    await validateAccount(this);
  }

  public async getPresaleRemaining() {
    const amount = await tokenPresaleRemaining();
    if (amount) {
      this.presaleRemaining = amount / this.exchangeRate;
    }
  }

  public async getUserRemaining() {
    const amount = Number(await canTokenPurchaseAmount(this.account));
    if (amount) {
      this.userRemaining = amount / this.exchangeRate;
    }
  }

  public async getTokenRaisedFund() {
    const amount = Number(await tokenRaisedFund());
    if (amount) {
      this.tokenRaisedFund = amount;
    }
  }

  public async getUserETHBalance() {
    const amount = Number(await userETHBalance(this.account));
    if (amount) {
      this.userETHBalance = amount;
    }
  }

  public async getExchangeRate() {
    const rate = Number(await exchangeRate());
    if (rate) {
      this.exchangeRate = rate;
    }
  }

  public async countChange() {
    if (this.count === '') {
      return;
    } else if (Number(this.count) <= 0) {
      this.count = '0';
    } else if (Number(this.count) >= this.minRemaing) {
      this.count = this.minRemaing.toString();
    }
  }

  public async handlePurchase() {
    tokenPurchase(Number(this.count), this.account);
  }

  public handleMaxCount() {
    this.count = this.minRemaing.toString();
  }

  public learnMore() {
    window.open('https://guide.alpaca.city/', '_blank');
  }

  @Watch('account', {immediate: true})
  public onAccount(val: string) {
    if (val) {
      this.countChange();
      this.getUserRemaining();
      this.getPresaleRemaining();
      this.getTokenRaisedFund();
      this.getUserETHBalance();
      this.getExchangeRate();
    }
  }
}
